import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { Profile } from './profile'

export class SitesProfilesRepository extends BaseRepository<Profile> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/sites/profiles', token, cache)
    }

    async updateTimezone(timezone: number) {
        const { json, statusCode, message } = await this.request.post(
            this.config.toolsApiUrl + '/sites/profiles/timezone?token=' + this.resolvedToken,
            { timezone },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
